export type AttributesFilterHandler = (args?: MutationRecord[]) => void;

export interface MutationObserverAttributesFilters {
  [key: string]: string;
}

export interface ScrollHandlers {
  [key: string]: AttributesFilterHandler;
}

export type MutationObserverCustomConfig = Exclude<
  keyof MutationObserverInit,
  'attributeFilter'
>[];

export enum ScrollType {
  Ticket = 'ticket',
  ItemScroll = 'itemScroll',
}

export interface ScrollStates {
  stateId?: string;
  isTouchDevice: boolean;
  isHorizontal: boolean;
  isVertical: boolean;
  isTop: boolean;
  isBottom: boolean;
  isLeft: boolean;
  isRight: boolean;
}

export interface ScrollControlStates {
  isHorizontal: boolean;
  isVertical: boolean;
  isTopBtnDisabled: boolean;
  isTopBtnFullContentDisabled: boolean;
  isBottomBtnDisabled: boolean;
  isBottomBtnFullContentDisabled: boolean;
  isLeftBtnDisabled: boolean;
  isLeftBtnFullContentDisabled: boolean;
  isRightBtnDisabled: boolean;
  isRightBtnFullContentDisabled: boolean;
  showTopBtn: boolean;
  showTopBtnFullContent: boolean;
  showBottomBtn: boolean;
  showBottomBtnFullContent: boolean;
  showRightBtn: boolean;
  showRightBtnFullContent: boolean;
  showLeftBtn: boolean;
  showLeftBtnFullContent: boolean;
  isTopFader: boolean;
  isBottomFader: boolean;
  isLeftFader: boolean;
  isRightFader: boolean;
  isVirtualHorizontalScrollShown: boolean;
  isVirtualVerticalScrollShown: boolean;
}

export interface DragStates {
  verticalDragHeight: number;
  horizontalDragWidth: number;
  dragTop: number;
  dragLeft: number;
  dragMaxY: number;
  dragMaxX: number;
}
